export enum WebAppRoles {
  GENERIC_USER = '1',
  LEGRAND_PARTNER = '2'
}

export enum BackofficeRoles {
  LEGRAND_SERVICE = 1,
  LEGRAND_ADMIN = 2
}
